import React from 'react';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { store, persistor } from 'common/store';
import { ThemeProvider } from '@mui/material/styles';
import { OidcProvider, loadUser } from 'redux-oidc';
import { regularUserManager } from './auth/userManager';
import Authenticate from './auth/Authenticate';
import defaultTheme from './common/theme';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import CssBaseline from '@mui/material/CssBaseline';
import { StylesProvider } from '@mui/styles';

loadUser(store, regularUserManager);

function App() {
  return (
    <Provider store={store}>
      <StylesProvider injectFirst>
        <ThemeProvider theme={defaultTheme}>
          <CssBaseline />
          <OidcProvider store={store} userManager={regularUserManager}>
            <PersistGate loading={null} persistor={persistor}>
              <BrowserRouter>
                <Authenticate />
              </BrowserRouter>
            </PersistGate>
          </OidcProvider>
        </ThemeProvider>
      </StylesProvider>
    </Provider>
  );
}

export default App;
